import { css } from 'styled-components'

export const reset = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
    padding: 0;
  }

  img,
  picture,
  video,
  iframe,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
`
